import { Card, CardBody } from "reactstrap";

// The honest "not tracked yet" card — for any tile/chart backed by a gap
// that isn't closed, or a feature (Tanya's audio/video, Raman's licensing)
// that hasn't merged yet. Never a zero, never a fake placeholder chart,
// never a silently-missing tile — a specific, muted explanation instead.
export default function EmptyState({ title, detail }) {
  return (
    <Card className="mcap-empty-state mt-3">
      <CardBody className="text-center py-5">
        <div className="mcap-empty-state-icon mb-2">◌</div>
        <p className="standard-typo-16-600 mb-1">{title}</p>
        {detail && <p className="standard-typo-14-400 mcap-empty-state-detail mb-0">{detail}</p>}
      </CardBody>
    </Card>
  );
}
